import * as React from 'react';
// form
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from '../../lib/utils';
import { sxParaEstilo } from './RHFTextField';

/* ============================================================================
   Caixas de selecao do visual novo. Sem MUI.

   A assinatura publica nao mudou: `name` e `label` (mais `sx`, `disabled` e
   `className`). A tela de politicas usa ~30 destes, varios dentro de <Tooltip>
   do MUI - por isso os dois componentes sao forwardRef: o Tooltip clona o filho
   e injeta um ref; componente de funcao sem forwardRef nessa posicao faz o React
   avisar no console e o tooltip nunca abre. Antes o ref chegava no
   FormControlLabel do MUI, que ja encaminhava.

   DEFEITO CORRIGIDO: `checked={field.value}` com o valor ainda `undefined` (campo
   novo, ou coluna nula vinda do banco) deixa o input NAO CONTROLADO no primeiro
   render e depois controlado - o React avisa e o primeiro clique pode nao
   registrar. Normalizado com Boolean().
   ============================================================================ */

const CLASSES_CAIXA =
  'h-4 w-4 flex-none cursor-pointer accent-primary disabled:cursor-not-allowed disabled:opacity-50';

// `@type {any}`: com `React.forwardRef` o TypeScript nao consegue inferir o tipo
// das props a partir do padrao de desestruturacao, e assume props vazias - o que
// faz TODO chamador .tsx quebrar em `name`, `fullWidth` etc. A versao anterior
// (MUI, `{ name, ...other }`) aceitava qualquer prop; isto preserva o mesmo
// contrato sem mexer nos chamadores.
/** @type {any} */
export const RHFCheckbox = React.forwardRef(function RHFCheckbox(
  {
    name,
    label,
    sx,
    className,
    disabled,
    // Aceitas e descartadas (eram do FormControlLabel do MUI).
    labelPlacement,
    size,
    color,
    ...resto
  },
  ref
) {
  const { control } = useFormContext();
  const idCampo = `check-${name}`;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        // O <label> envolve o input e o texto: clique no texto marca a caixa sem
        // precisar de htmlFor. Nao ha nenhum botao aqui dentro, entao envolver e
        // seguro. `...resto` vai no label porque e por ele que o Tooltip do MUI
        // passa onMouseEnter/aria-describedby.
        <label
          {...resto}
          ref={ref}
          htmlFor={idCampo}
          style={sxParaEstilo(sx)}
          className={cn(
            'flex cursor-pointer items-center gap-2 text-[12.5px] text-ink',
            disabled && 'cursor-not-allowed text-muted-foreground',
            className
          )}
        >
          <input
            // `value` do field fica DE FORA de proposito: aqui ele e booleano, e
            // um checkbox com value="true"/"false" e ruido no HTML - o estado do
            // checkbox mora em `checked`.
            name={field.name}
            ref={field.ref}
            onChange={field.onChange}
            onBlur={field.onBlur}
            id={idCampo}
            type="checkbox"
            checked={Boolean(field.value)}
            disabled={Boolean(disabled)}
            className={CLASSES_CAIXA}
          />
          {label && <span>{label}</span>}
        </label>
      )}
    />
  );
});

// ----------------------------------------------------------------------


export function RHFMultiCheckbox({ name, options = [], sx, className, disabled, ...resto }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        // Lista pode chegar undefined antes do reset; sem a guarda o `.includes`
        // abaixo estoura.
        const marcados = Array.isArray(field.value) ? field.value : [];

        const alternar = (opcao) =>
          marcados.includes(opcao) ? marcados.filter((v) => v !== opcao) : [...marcados, opcao];

        return (
          <div className={cn('flex flex-col gap-1.5', className)} style={sxParaEstilo(sx)}>
            {options.map((opcao) => (
              <label
                key={opcao}
                className={cn(
                  'flex cursor-pointer items-center gap-2 text-[12.5px] text-ink',
                  disabled && 'cursor-not-allowed text-muted-foreground'
                )}
              >
                <input
                  type="checkbox"
                  name={field.name}
                  checked={marcados.includes(opcao)}
                  disabled={Boolean(disabled)}
                  onChange={() => field.onChange(alternar(opcao))}
                  onBlur={field.onBlur}
                  className={CLASSES_CAIXA}
                />
                <span>{opcao}</span>
              </label>
            ))}
          </div>
        );
      }}
    />
  );
}
